module.exports = __webpack_public_path__ + "static/media/manzo_09_thumb_hover.c097e126.png";